<div
  class="bg-elevated flex flex-col gap-1.5 rounded-r-xs border-l-2 py-1.5 pl-2.5"
  [class.border-accent-border]="!negatesSomething()"
  [class.g-negated-rail]="negatesSomething()"
  [class.is-linked]="linked()"
  [attr.data-path-node]="association().id">
  <div class="g-filter-row text-text-secondary items-center text-xs">
    <div class="col-span-3 flex min-w-0 flex-wrap items-center gap-1.5">
      <div class="gx-segmented is-sm" role="radiogroup" [attr.aria-label]="label()">
        @for (option of modes(); track option) {
          <button
            type="button"
            role="radio"
            class="seg"
            [class.is-active]="mode() === option"
            [class.is-negation]="option === 'no'"
            [attr.aria-checked]="mode() === option"
            (click)="setMode(option)">
            {{ 'features.data.path_filter.association.mode.' + option | translate }}
          </button>
        }
      </div>
      <span
        >{{ phrase().before
        }}<span class="text-text-primary font-semibold">{{ phrase().noun }}</span
        >{{ phrase().after }}</span
      >
      @if (showsBodyMode()) {
        <div
          class="gx-segmented is-sm"
          role="radiogroup"
          [attr.aria-label]="
            'features.data.path_filter.group.of_these_true.' + bodyMode() | translate
          ">
          @for (option of bodyModes; track option) {
            <button
              type="button"
              role="radio"
              class="seg"
              [class.is-active]="bodyMode() === option"
              [class.is-negation]="option === 'none'"
              [attr.aria-checked]="bodyMode() === option"
              (click)="setBodyMode(option)">
              {{ bodyModeLabels()[option] }}
            </button>
          }
        </div>
        <span>{{
          'features.data.path_filter.group.of_these_true.' + bodyMode() | translate
        }}</span>
      }
    </div>
    <button
      type="button"
      class="text-text-tertiary hover:text-danger hover:bg-danger-soft inline-flex cursor-pointer rounded-xs p-1.5 transition-colors"
      [attr.aria-label]="'features.data.path_filter.association.remove' | translate"
      (click)="removed.emit()">
      <i [class]="ICONS.trash" aria-hidden="true"></i>
    </button>
  </div>
  <ng-content />
</div>
